import React from 'react'
// import './Navbar.scss'
import { navData } from '../../navData.js'
import { NavLink } from 'react-router-dom'

const Navbar = ({ handleNavToggle }) => {
    return (
        <header className='header'>
            <picture className='header__logo-container'>
                <img
                    className='header__logo-img'
                    src='./assets/shared/logo.svg'
                    alt='logo'
                />
            </picture>
            <div className='header__nav-line'></div>
            <nav className='header__nav'>
                <ul className='header__nav-list '>
                    {navData.map((navLink, index) => {
                        let destinationText = navLink === '/' ? 'home' : navLink
                        return (
                            <li key={index} className='header__nav-item'>
                                <NavLink
                                    to={navLink}
                                    className={({ isActive }) =>
                                        isActive
                                            ? 'header__nav-link active'
                                            : 'header__nav-link'
                                    }
                                >
                                    {destinationText}
                                </NavLink>
                            </li>
                        )
                    })}
                </ul>
            </nav>
            <img
                className='header__hamburger'
                src='./assets/shared/icon-hamburger.svg'
                alt='Navbar Menu Options'
                onClick={() => handleNavToggle()}
            />
        </header>
    )
}

export default Navbar
